import React from 'react';
import { Provider } from 'react-redux';
import 'AppSrc/core/style/app.css';
import { store } from 'AppSrc/core/store/store';
import { AuthRouter } from 'AppSrc/core/components/router/router-auth';
import { ErrorAlert } from 'AppSrc/core/components/error-alert/error-alert';

const App = () => (
  <Provider store={store}>
    <AuthRouter />
    <ErrorAlert />
  </Provider>
);


export { App };
